"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AcTableColumn_1 = require("./AcTableColumn");
var AcTableItem_1 = require("./AcTableItem");
/**
 * AcTable Data Storage and Processing
 */
var useAcTableData = function (props) {
    var _a = react_1.useState(AcTableColumn_1.AcTableColumn.fromColumns(props.columns)), acTableColumns = _a[0], setAcTableColumns = _a[1];
    var _b = react_1.useState(AcTableItem_1.AcTableItem.fromData(props.data, props.functionContext)), acTableItems = _b[0], setAcTableItems = _b[1];
    /**
     * Refresh columns state with a new configuration
     * @param data
     */
    var setColumns = function (columns) {
        return setAcTableColumns(AcTableColumn_1.AcTableColumn.fromColumns(columns));
    };
    var setData = function (data) {
        return setAcTableItems(AcTableItem_1.AcTableItem.fromData(data));
    };
    var selectItem = function (index) {
        var clonedItems = acTableItems.slice();
        if (index >= 0 && index < clonedItems.length) {
            clonedItems[index].selected = !clonedItems[index].selected;
        }
        setAcTableItems(clonedItems);
    };
    var selectAllItems = function (checked) {
        var clonedItems = acTableItems.slice();
        clonedItems.forEach(function (item) { return (item.selected = checked); });
        setAcTableItems(clonedItems);
    };
    var getSelectedItems = function () {
        var clonedItems = acTableItems.slice();
        return clonedItems.filter(function (item) { return item.selected; }).map(function (item) { return item.data; });
    };
    var getSelectedData = function () {
        var clonedItems = acTableItems.slice();
        var first = clonedItems.find(function (item) { return item.selected; });
        if (first)
            return first.data;
        return undefined;
    };
    return {
        acTableColumns: acTableColumns,
        setAcTableColumns: setAcTableColumns,
        acTableItems: acTableItems,
        setAcTableItems: setAcTableItems,
        setColumns: setColumns,
        setData: setData,
        selectItem: selectItem,
        selectAllItems: selectAllItems,
        getSelectedItems: getSelectedItems,
        getSelectedData: getSelectedData,
    };
};
exports.useAcTableData = useAcTableData;
exports.default = useAcTableData;
//# sourceMappingURL=UseAcTableData.js.map